import config from '@/config';
import useCache from '@/hooks/useCache';
import useNavigateToArtwork from '@/hooks/useNavigateToArtwork';
import useTranslations from '@/i18n/useTranslations';
import Loader from '@/shared-components/loader/Loader';
import ActivityHeading from '@/shared-components/text/components/ActivityHeading';
import Text from '@/shared-components/text/components/Text';
import { filterRenderableArtworkGridItems } from '@/utils/activityContent';

import VirtualList from './components/VirtualList';

import './index.css';

export default function SavedArtworks() {
  const t = useTranslations('common.profile.activity');
  const { loading, fetchData, loadMoreData } = useCache("saved_artworks", `${config.apis.api.url}/saved/artworks`, {
    injectToken: true,
    invalidateWhen: ["SAVE_ARTWORK"]
  });
  const safeFetchData = fetchData ?? { data: [], totalDocs: 0 };
  const visibleArtworks = filterRenderableArtworkGridItems(safeFetchData.data);
  const visiblePage = { ...safeFetchData, data: visibleArtworks, totalDocs: visibleArtworks.length };
  const activityTitle = t('menu.saved_artworks');
  const navigateToArtwork = useNavigateToArtwork(
    "saved_artworks",
    visiblePage,
    "/saved/artworks?",
    { type: 'activity-menu', label: activityTitle }
  );
  
  return (
    <>
      <ActivityHeading text={activityTitle}/>
      <div className="activity-saved-artworks__container">
        {
          loading ? 
            <Loader />
            : visibleArtworks.length === 0 ? 
              <Text className="activity-saved-artworks__text font-size-medium">
                {t('empty.saved_artworks')}
              </Text>
              :
              <VirtualList 
                items={safeFetchData}
                visibleItems={visibleArtworks}
                onLoadMore={loadMoreData}
                navigateToArtwork={navigateToArtwork}
              />
        }
      </div>
    </>
  );
}
